import { render, staticRenderFns } from "./CreateLeadFormStep4.vue?vue&type=template&id=61cc91d4&"
import script from "./CreateLeadFormStep4.vue?vue&type=script&lang=ts&"
export * from "./CreateLeadFormStep4.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLeadFormStep4.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports